<template>
  <span class="svg-ico-ellipsis-horizontal">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.53906 12.8281C6.53906 13.9327 5.64363 14.8281 4.53906 14.8281C3.43449 14.8281 2.53906 13.9327 2.53906 12.8281C2.53906 11.7236 3.43449 10.8281 4.53906 10.8281C5.64363 10.8281 6.53906 11.7236 6.53906 12.8281Z" :fill="color"/>
      <path d="M14.5391 12.8281C14.5391 13.9327 13.6436 14.8281 12.5391 14.8281C11.4345 14.8281 10.5391 13.9327 10.5391 12.8281C10.5391 11.7236 11.4345 10.8281 12.5391 10.8281C13.6436 10.8281 14.5391 11.7236 14.5391 12.8281Z" :fill="color"/>
      <path d="M22.5391 12.8281C22.5391 13.9327 21.6436 14.8281 20.5391 14.8281C19.4345 14.8281 18.5391 13.9327 18.5391 12.8281C18.5391 11.7236 19.4345 10.8281 20.5391 10.8281C21.6436 10.8281 22.5391 11.7236 22.5391 12.8281Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
